<template>
  <div class="prize-calc">
    <div class="prize-calc__top">
      <div class="prize-calc__box-info">
        {{
          product.drawInfo.estimatedPrize > 0
            ? "R$ " + product.drawInfo.estimatedPrizeText
            : product.drawInfo.estimatedPrizeText
        }}
      </div>

      <div class="prize-calc__box-info">Nº de cotas: {{ qtdQuotas }}</div>

      <div class="prize-calc__box-info">
        Valor Cota: {{ intToReal(valueQuota) }}
      </div>
    </div>
    <div class="prize-calc__inputs">
      <fieldset class="prize-calc__inputs__fieldset">
        <label for="">Nº de apostas ganhadoras</label>
        <button
          class="prize-calc__btn-info"
          title="Informações"
          trigger
          v-tooltip="
            'Simule quantas apostas acertariam <strong>todas as dezenas</strong> sorteadas no concurso'
          "
        >
          <i class="fa fa-info"></i>
        </button>
       <div class="position-relative">
        <button
            @click="addWinBets"
          class="add-quotes"
          >
            &lsaquo;
          </button>
          <button
            @click="lessWinBets"
            class="less-quotes"
          >
            &lsaquo;
          </button>
        <input v-model="winnerBets" type="number" />
       </div>
      </fieldset>

      <fieldset class="prize-calc__inputs__fieldset">
        <label for="">Qtd. de cotas adquiridas</label>
        <button
          class="prize-calc__btn-info"
          title="Informações"
          trigger
          v-tooltip="
            'Simule a <strong>quantidade de cotas</strong> que você compraria deste bolão'
          "
        >
          <i class="fa fa-info"></i>
        </button>
        <div class="position-relative">
          <button
            @click="addQuotes"
          class="add-quotes"
          >
            &lsaquo;
          </button>
          <button
            @click="lessQuotes"
            class="less-quotes"
          >
            &lsaquo;
          </button>
          <input v-model="acquiredQuotas" type="number" />
        </div>
      </fieldset>
    </div>
    <div class="prize-calc__result">
      <ul class="prize-calc__result__list">
        <li class="prize-calc__result__list__item">
          <span class="prize-calc__result__list__item__title"
            >Valor investido</span
          >
          <span class="prize-calc__result__list__item__value">{{
            investedAmount ? intToReal(investedAmount) : " - "
          }}</span>
        </li>
        <li class="prize-calc__result__list__item">
          <span class="prize-calc__result__list__item__title"
            >Prêmio Recebido</span
          >
          <span
            class="prize-calc__result__list__item__value prize-calc__result__list__item__value--prize"
            >{{ prizeReceived ? intToReal(prizeReceived) : " - " }}</span
          >
        </li>
        <li class="prize-calc__result__list__item">
          <span class="prize-calc__result__list__item__title">Rendimento</span>
          <span class="prize-calc__result__list__item__value">{{
            prizeReceived
              ? (prizeReceived / investedAmount).toFixed(0) + "x"
              : " - "
          }}</span>
        </li>
      </ul>
      <button @click="handleCalc()" class="btn btn-block">Simular</button>
    </div>
  </div>
</template>

<script>
import intToReal from '@helpers/intToReal';

export default {
  props: {
    product: null
  },
  data: function () {
    return {
      prizeReceived: null,
      investedAmount: null,
      winnerBets: 1,
      acquiredQuotas: 1,
      valueQuota: 0,
      qtdQuotas: 0,
      prizeAmount: 0
    };
  },
  watch: {},
  methods: {
    intToReal,
    handleInvestedAmount () {
      this.investedAmount = this.acquiredQuotas * this.valueQuota;
      return this.investedAmount;
    },
    handlePrizeReceived () {
      this.prizeReceived =
        (this.prizeAmount / this.winnerBets / this.qtdQuotas) *
        +this.acquiredQuotas;
      return this.prizeReceived;
    },
    handleCalc () {
      if (this.acquiredQuotas > this.qtdQuotas) {
        this.$toast.open({
          type: 'error',
          message:
            'O número de cotas adquiridas não pode ser maior que o número de cotas'
        });
        return;
      }

      if (this.winnerBets < 1) {
        this.$toast.open({
          type: 'error',
          message: 'O número de apostas ganhadoras não pode ser menor que 1'
        });
        return;
      }

      if (this.acquiredQuotas < 1) {
        this.$toast.open({
          type: 'error',
          message: 'O número de cotas adquiridas não pode ser menor que 1'
        });
        return;
      }

      this.handleInvestedAmount();
      this.handlePrizeReceived();
    },
    addQuotes () {
      if (this.acquiredQuotas < this.qtdQuotas) {
        this.acquiredQuotas++;
      }
    },
    lessQuotes () {
      if (this.acquiredQuotas > 1) {
        this.acquiredQuotas--;
      }
    },
    addWinBets () {
      this.winnerBets++;
    },
    lessWinBets () {
      if (this.winnerBets > 1) {
        this.winnerBets--
      }
    }
  },
  mounted () {
    this.qtdQuotas = this.product.units;
    this.valueQuota = this.product.unitPrice;
    this.prizeAmount = this.product.drawInfo.estimatedPrize;
  }
};
</script>

<style lang="scss" scoped>
.prize-calc {
  border: 1px solid #dbdbdb;
  border-radius: 8px;
  padding: 16px;
  h1 {
    font-size: 24px;
  }
  &__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-bottom: 20px;

    @media screen and (max-width: 992px) {
      flex-wrap: wrap;
    }
  }

  &__box-info {
    background-color: #f8f8f8;
    padding: 10px;
    border-radius: 5px;
    width: 100%;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;

    @media screen and (max-width: 992px) {
      &:not(:last-child) {
        flex: 1;
        width: auto;
      }

      &:last-child {
        width: 100%;
      }
    }
  }

  &__inputs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    @media screen and (max-width: 992px) {
      flex-direction: column;
      gap: 16px;
    }

    &__fieldset {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      border: none;
      margin: 0;
      padding: 0;
      @media screen and (max-width: 992px) {
        width: 100%;
        justify-content: space-between;
      }

      [type="number"] {
        width: 100%;
        padding: 10px;
        border-radius: 5px;
        border: 1px solid #f1f1f1;
        width: 74px;
        flex-shrink: 0;
      }
      input[type="number"]::-webkit-inner-spin-button,
      input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      label {
        max-width: 188.16px;
        width: 100%;
        @media screen and (min-width: 992px) {
          width: auto;
        }
      }
    }
    .less-quotes{
      transform: rotate(-90deg);
      font-size: 18px;
      font-weight: 900;
      background: transparent;
      border: 0;
      color:#9d9d9d;
      position: absolute;
      right: 1px;
      top:15px;
      cursor: pointer;
      &:hover{
        color: #000;
      }
    }
    .add-quotes{
      transform: rotate(90deg);
      font-size: 18px;
      font-weight: 900;
      background: transparent;
      border: 0;
      color: #9d9d9d;
      position: absolute;
      right: 0;
      cursor: pointer;
      &:hover{
      color: #000;
    }
    }
  }

  &__result {
    background-color: #fff;
    border-radius: 5px;
    width: 100%;
    text-align: center;
  }

  &__result__list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    margin-bottom: 8px;
  }

  &__result__list__item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    height: 49px;
    border-bottom: 1px solid #dbdbdb;
    padding: 0 8px;

    &:last-of-type {
      border-bottom: none;
    }
  }

  &__result__list__item__value {
    font-size: 16px;
    font-weight: 700;

    &.prize-calc__result__list__item__value--prize {
      color: #3fbfff;
      font-size: 24px;

      @media screen and (max-width: 992px) {
        font-size: 18px;
      }
    }
  }

  .prize-calc__btn-info {
    margin: 0;
    appearance: none;
    padding: 0;
    background-image: none;
    outline: none;
    border-radius: 50%;
    background-color: transparent;
    cursor: pointer;
    font-size: 16px;
    width: 1em;
    height: 1em;
    border: 0.13em solid rgb(0 0 0 / 45%);
    display: inline-flex;
    justify-content: center;
    align-items: center;

    .fa {
      font-size: 0.5em;
      line-height: 1;
      color: rgb(0 0 0 / 45%);
    }

    @media screen and (min-width: 992px) {
      &:hover {
        border: 0.1em solid rgb(0 0 0 / 50%);

        .fa {
          color: rgb(0 0 0 / 50%);
        }
      }

      &.v-tooltip-open {
        border: 0.1em solid #ececec;

        .fa {
          color: #ececec;
        }
      }
    }
  }
}
</style>
